import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addonUninstall } from '@api/sdk.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';

import { queryKeys } from '../query-keys';

export function useUninstallAddon(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => addonUninstall({ path: { id } }),
    // Stay pending until the list refresh settles so callers redirect to an
    // up-to-date list. Invalidating list() also refreshes the switcher's lite
    // variant.
    ...withInvalidate(queryClient, [queryKeys.list(), queryKeys.detail(id)]),
    ...withError('Unable to uninstall add-on'),
  });
}
